function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import LinePlot from './Line';
import BarPlot from './Bar';
import MapPlot from './Map';
import ScatterPlot from './Scatter';
import 'scss/cndc_prices.scss';

var PlotSection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PlotSection, _React$Component);

  function PlotSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PlotSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PlotSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.shouldComponentUpdate = function (nextProps) {
      if (_this.props.plot != nextProps.plot) return true;
      return false;
    };

    _this.fetch = function () {
      if (_this.props.plot.init) return;
      var pathname = "/countries/".concat(_this.props.countryID).concat(_this.props.plot.metadata.url);
      var meta_pathname = "/countries/".concat(_this.props.countryID).concat(_this.props.plot.metadata.url, "/metadata");

      _this.props.actions.toggleLoadingPlotData(_this.props.countryID, _this.props.plot.metadata.id);

      _this.props.actions.fetchData("".concat(_this.props.countryID, "/").concat(_this.props.plot.metadata.id), pathname, _this.props.actions.savePlotData);

      _this.props.actions.fetchData("".concat(_this.props.countryID, "/").concat(_this.props.plot.metadata.id), meta_pathname, _this.props.actions.savePlotMetaData);
    };

    _this.componentDidMount = function () {
      _this.fetch();
    };

    _this.render = function () {
      var _this$props = _this.props,
          plot = _this$props.plot,
          actions = _this$props.actions,
          countryID = _this$props.countryID,
          plotID = _this$props.plotID,
          windowWidth = _this$props.windowWidth,
          type = _this$props.type,
          format = _this$props.format,
          height = _this$props.height;
      if (type === 'scatter') return React.createElement(ScatterPlot, {
        height: height,
        type: type,
        plot: plot,
        actions: actions,
        plotID: plotID,
        countryID: countryID,
        controls: plot.controls,
        windowWidth: windowWidth
      });
      if (type === 'map') return React.createElement(MapPlot, {
        panel: true,
        height: height,
        type: type,
        plot: plot,
        actions: actions,
        plotID: plotID,
        countryID: countryID,
        controls: plot.controls,
        windowWidth: windowWidth
      });

      if (type === 'bar') {
        return React.createElement(BarPlot, {
          format: format,
          height: height,
          type: type,
          plot: plot,
          actions: actions,
          plotID: plotID,
          countryID: countryID,
          controls: plot.controls,
          windowWidth: windowWidth
        });
      }

      if (type === 'line') return React.createElement(LinePlot, {
        height: height,
        plot: plot,
        section: true,
        panel: true,
        actions: actions,
        plotID: plotID,
        countryID: countryID,
        controls: plot.controls,
        windowWidth: windowWidth
      });
      if (type === 'scatter') return React.createElement(BarPlot, {
        format: format,
        plot: plot,
        actions: actions,
        plotID: plotID,
        countryID: countryID,
        controls: plot.controls,
        windowWidth: windowWidth
      });
      return React.createElement("div", null);
    };

    return _this;
  }

  return PlotSection;
}(React.Component);

export { PlotSection as default };
PlotSection.propTypes = {
  plotID: PropTypes.string,
  format: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string,
  plot: PropTypes.object,
  loading: PropTypes.bool,
  countryID: PropTypes.string,
  actions: PropTypes.object,
  windowWidth: PropTypes.number,
  checkboxState: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};